<template>
  <transition name="fade">
     <div class="spinner" v-if="pending">
       <div class="spinner_circle"></div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["pending"]),
  },
};
</script>

<style>
.spinner{
  position:fixed; 
  top:0; 
  left:0; 
  width:100%; 
  height:100%; 
  z-index:9999;
}
.spinner_circle {
  width:40px; 
  height:40px;
  border-radius: 50%;
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
  text-indent: -9999em;
  border: 3px solid #E5E5E5;
}
.spinner_circle:after{
  content:""; 
  display:block;
  width:40px;
  height:40px;
  border-radius:50%;
  border-width:3px;
  border-style:solid;
  border-color:transparent transparent #ED2024 transparent;
  position:absolute; 
  top:-3px; 
  left:-3px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
